import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {ConsultaBancoService} from "../../../services/consulta-banco/consulta-banco.service";
import {ConsultaBanco} from "../../../core/consulta-banco";

@Component({
    selector: 'combo-consulta-banco',
    templateUrl: './combo-consulta-banco.component.html',
    styleUrls: ['./combo-consulta-banco.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboConsultaBancoComponent implements OnInit {

    @ViewChild('comboConsultaBanco', {static: false}) comboConsultaBanco;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;
    @Input() label = 'Consulta Banco';
    @Input() tipoConsulta = 'U';

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private consultaBancoService: ConsultaBancoService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.consultaBancoService.getCombo(this.tipoConsulta).subscribe((consultas: ConsultaBanco[]) => {
                this.dados = consultas;
                this.preencherCombo();
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }


}
